// Aislado de src/utils.js (Kofides contable): clave de storage y prefijo de
// API propios para que SIGTE nunca choque con la sesion de Kofides.

export var SIGTE_API = "/api/sigte";
export var SIGTE_SESSION_KEY = "sigte_session";

export var sls = {
  get: function(k,fb){ try{ var v=localStorage.getItem(k); return v?JSON.parse(v):fb; }catch(e){return fb;} },
  set: function(k,v){ try{ localStorage.setItem(k,JSON.stringify(v)); }catch(e){} },
};

export function sigteApiFetch(path, opts) {
  opts = opts || {};
  var session = sls.get(SIGTE_SESSION_KEY, null);
  var headers = Object.assign({}, opts.headers);
  if (!(opts.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }
  if (session && session.token) {
    headers["Authorization"] = "Bearer " + session.token;
  }
  return fetch(SIGTE_API + path, Object.assign({}, opts, { headers: headers }));
}

// Envuelve sigteApiFetch: si la respuesta no es ok, lanza un Error con el
// mensaje del backend (o uno generico si el cuerpo no es JSON valido) en vez
// de dejar que la operacion siga como si hubiera tenido exito.
export async function sigteApiFetchChecked(path, opts) {
  var r = await sigteApiFetch(path, opts);
  var body = null;
  try {
    body = await r.json();
  } catch (e) {
    body = null;
  }
  if (!r.ok) {
    var msg = (body && body.error) ? body.error : "Error inesperado del servidor (" + r.status + ").";
    throw new Error(msg);
  }
  return body;
}
